import React from 'react';

const renderField = ({
  input, label, type, meta: { touched, error },
}) => (
  <div>
    <label>{label}</label>
    <div>
      <textarea {...input} type={type} />
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);

export default renderField;



// WEBPACK FOOTER //
// ./src/Components/Inputs/Textarea.jsx